import { useEffect } from 'react';

import logger from '@/logger';
import useStore from '@/store';
import { getDesktopVersion, getVersion } from '@/utils';
import { isDesktop } from '@/utils/helper';

const useGetAppVersion = () => {
  const { setAppVersion } = useStore();
  useEffect(() => {
    const fetchVersion = async () => {
      try {
        if (isDesktop()) {
          const result = await getDesktopVersion();
          setAppVersion(result);
        } else {
          setAppVersion(getVersion());
        }
      } catch (error) {
        logger.error('Failed to fetch version:', error);
      }
    };

    fetchVersion().catch((error) => {
      logger.error('Failed to fetch version:', error);
    });
  }, [setAppVersion]);
};

export default useGetAppVersion;
